import React, { useEffect, useState, useContext } from 'react';
import { ResponsiveHeader } from '../responsive-header/ResponsiveHeader';

import { SkipLinks } from '../link-list/SkipLinks';
import { skipLinks } from '../links';
import { authenticateUser } from '../../../client/authenticate-user';
import { Navigation } from '../navigation/Navigation';
import styles from './header-wrapper.scss';
import { UserContext } from '../../scaffold/UserContext';
import { getUserProfileFromCookies } from '../../../client/getUserProfileFromCookies';
import { getNotificationLite } from '../../../client/fetch/get-notification-lite';

interface HeaderWrapperProps {
  features: Features;
  notificationLiteIsActive?: boolean;
  notificationLiteUrl?: string;
}

export const HeaderWrapper = ({
  features,
  notificationLiteIsActive,
  notificationLiteUrl,
}: HeaderWrapperProps) => {
  const [mobileNavShown, setMobileNavShown] = useState<boolean>(false);
  const [typeaheadIsOpen, setTypeaheadIsOpen] = useState<boolean>(false);

  const { updateUserState } = useContext(UserContext);

  useEffect(
    function initUserState() {
      (async () => {
        const userProfile = features.authenticationEnabled
          ? await authenticateUser()
          : getUserProfileFromCookies();

        if (userProfile) {
          updateUserState(userProfile);
          if (
            notificationLiteUrl &&
            notificationLiteIsActive &&
            userProfile.user.signedIn &&
            !userProfile.user.notifications?.hasNotification
          ) {
            /* only call api if user is signed in and notifications have not already been set via cookie */
            const notifications =
              await getNotificationLite(notificationLiteUrl);
            if (notifications?.hasNotification) {
              updateUserState({
                ...userProfile,
                user: {
                  ...userProfile.user,
                  notifications,
                },
              });
            }
          }
        }
      })();
    },
    [
      features.authenticationEnabled,
      notificationLiteIsActive,
      notificationLiteUrl,
    ]
  );

  /* temporary requirement to allow both standard and premium to set global css values without conflicting with each other */
  useEffect(function setPremiumHeaderHtmlClass() {
    document.documentElement.classList.add('jl-premium-header');
    return () => document.documentElement.classList.remove('jl-premium-header');
  }, []);

  return (
    <header className={styles.siteWide} data-testid="premium-header-wrapper">
      <div className={styles.headerContainer}>
        <SkipLinks links={skipLinks} />

        <ResponsiveHeader
          updateMobileNavState={setMobileNavShown}
          updateTypeaheadState={setTypeaheadIsOpen}
        >
          <Navigation
            mobileNavShown={mobileNavShown}
            typeaheadIsOpen={typeaheadIsOpen}
          />
        </ResponsiveHeader>
      </div>
    </header>
  );
};
